module.exports = __webpack_public_path__ + "static/media/Pig.0ebf0f8d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Icons/Pig.svg
// module id = 1151
// module chunks = 0